import React from 'react'
import styled from 'styled-components'

export const Loader: React.FC = () => {
  return (
    <Wrapper>
      <Node />
    </Wrapper>
  )
}

const Node = styled.div`
  height: 25px;
  width: 25px;
  border: 4px solid currentcolor;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: 1s node linear infinite;
  position: relative;
  @keyframes node {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.5);
`
